import { render } from "./PaletteOutline.vue.js?vue&type=template&id=1b51fffe!=!../vue-loader/dist/index.js??ruleSet[0]!./PaletteOutline.vue?vue&type=template&id=1b51fffe"
import script from "./PaletteOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./PaletteOutline.vue?vue&type=script&lang=js"
export * from "./PaletteOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./PaletteOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__